import React, { createContext, useContext, useReducer } from "react";

const initalState: any = {};

const SearchContext = createContext<{
  data: any;
  dispatchData: React.Dispatch<any>;
}>({
  data: initalState,
  dispatchData: () => null,
});

const SearchContextProvider: React.FunctionComponent<any> = ({ children }) => {
  const searchDataDisptach = (state: any, inputData: any): any => {
    switch (inputData.case) {
      case "ADD":
        return { ...state, [inputData.payload.key]: inputData.payload.data };
      default:
        return state;
    }
  };

  const [data, dispatchData] = useReducer(searchDataDisptach, initalState);

  return (
    <SearchContext.Provider value={{ data, dispatchData }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const searchContext = useContext(SearchContext);
  return searchContext;
};

export default SearchContextProvider;
